import { useContext } from "react";
import ReportShowAllCheckbox from "components/ReportShowAllCheckbox";
import { TrendReportContext } from "contexts/TrendReportContext/TrendReportContext";

const DowntimeSummaryByProductionLineCheckbox = () => {
    const {
        showAllProductionLines,
        selectedProductionLine,
        selectedPreviousProductionLine,
        handleShowAllProductionLinesChange,
        handleSelectedProductionLineChange,
        handleSelectedPreviousProductionLineChange,
    } = useContext(TrendReportContext);

    return (
        <ReportShowAllCheckbox
            checked={showAllProductionLines}
            onChange={(_, checked) => {
                handleShowAllProductionLinesChange(checked);
                if (checked) {
                    handleSelectedPreviousProductionLineChange(selectedProductionLine);
                    handleSelectedProductionLineChange(undefined);
                } else {
                    handleSelectedProductionLineChange(selectedPreviousProductionLine);
                }
            }}
        />
    );
};

export default DowntimeSummaryByProductionLineCheckbox;
